import { useEffect } from 'react';

import { IPanorama } from '@ael/core-api';

/**
 * Handles the click inside a Panorama.
 * Event handler gets always overriden by a new handler.
 * When unmounting the component the handler is removed from Panorama.
 *
 * @param panorama Panorama for which to handle the click event.
 * @param onClick Handles the click inside a panorama.
 */
export const usePanoramaOnClick = (
  panorama: IPanorama | null,
  onClick?: (clickedInPanorama: IPanorama) => void
): void => {
  useEffect(() => {
    if (!panorama) {
      return;
    }

    onClick && panorama.registerOnClick(() => onClick(panorama));
    return () => panorama.unregisterOnClick();
  }, [onClick, panorama]);
};
